// ============================================================================
// dueDate.js — utilidades de la fecha de vencimiento de tareas
// ============================================================================
// La fecha viaja SIEMPRE como string ISO 'YYYY-MM-DD' (columna DATE, sin hora).
// Todas las comparaciones se hacen contra el "hoy" LOCAL del navegador y por
// COMPARACIÓN DE STRING ISO, nunca con new Date('YYYY-MM-DD') (que parsea en
// UTC y puede desplazar un día en husos negativos). Para ordenar/comparar
// fechas ISO 'YYYY-MM-DD' el orden lexicográfico coincide con el cronológico.

// "Hoy" local como 'YYYY-MM-DD' (usa getFullYear/getMonth/getDate → hora local).
export function todayLocalISO() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// Normaliza un valor de fecha entrante a 'YYYY-MM-DD' o null.
// Acepta ya-ISO ('YYYY-MM-DD') o un datetime cuyo prefijo sea la fecha
// ('YYYY-MM-DD HH:MM:SS'). Cualquier otra cosa → null.
export function normalizeDueDate(value) {
  if (!value || typeof value !== 'string') return null;
  const m = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? m[0] : null;
}

// Estado de la fecha respecto a hoy. `estado` es el estado de la tarea:
// una tarea COMPLETADA nunca se marca como atrasada.
//   'none'     → sin fecha
//   'overdue'  → fecha < hoy y no completada  (rojo, "Atrasada")
//   'today'    → fecha === hoy                 (ámbar, "Vence hoy")
//   'upcoming' → fecha > hoy (o completada)    (neutro)
export function getDueDateStatus(fechaVencimiento, estado) {
  const iso = normalizeDueDate(fechaVencimiento);
  if (!iso) return 'none';
  const today = todayLocalISO();
  const completed = estado === 'completada';
  if (iso === today) return completed ? 'upcoming' : 'today';
  if (iso < today) return completed ? 'upcoming' : 'overdue';
  return 'upcoming';
}

// Etiqueta corta del estado para el indicador del panel (o null si no aplica).
export function getDueDateStatusLabel(status) {
  if (status === 'overdue') return 'Atrasada';
  if (status === 'today') return 'Vence hoy';
  return null;
}

// Formatea una fecha ISO a "3 jul 2026" en local, construyendo la fecha con el
// constructor de componentes (new Date(y, m-1, d)) para no cruzar husos.
export function formatDueDate(fechaVencimiento) {
  const iso = normalizeDueDate(fechaVencimiento);
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}
